/**
 * The route-level loading state (ADR 0029): the page model's shape rather than
 * a spinner. A frame, a glance row of four figures, and an 8/4 work row stand
 * where the page will, so nothing jumps when the route resolves. `rail`
 * reserves the shell's rail and mobile bar for a signed-in destination. The
 * status copy is announced, not drawn. The stand-in fills the viewport and
 * never scrolls: a narrow viewport clips the work row below the fold rather
 * than growing the document past it.
 */
import { Skeleton } from "@/components/ui/skeleton";

interface RouteSkeletonProps {
  rail?: boolean;
  label?: string;
}

export function RouteSkeleton({ rail = false, label = "Loading your workspace" }: RouteSkeletonProps) {
  return (
    <div className="flex h-svh w-full overflow-hidden bg-background" aria-busy="true">
      <span role="status" className="sr-only">{label}</span>
      {rail && (
        <div aria-hidden="true" className="hidden w-[var(--layout-sidebar-width)] shrink-0 border-r bg-sidebar md:block" />
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        {rail && <div aria-hidden="true" className="h-[var(--layout-header-height)] shrink-0 border-b md:hidden" />}
        <div className="app-page min-h-0 overflow-hidden" aria-hidden="true">
          <div className="grid gap-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-72 max-w-full" />
            <Skeleton className="h-4 w-96 max-w-full" />
          </div>
          <div className="grid grid-cols-2 gap-[var(--layout-bento-gap)] lg:grid-cols-4">
            <Skeleton className="h-[5.5rem] rounded-xl" />
            <Skeleton className="h-[5.5rem] rounded-xl" />
            <Skeleton className="h-[5.5rem] rounded-xl" />
            <Skeleton className="h-[5.5rem] rounded-xl" />
          </div>
          <div className="grid gap-[var(--layout-bento-gap)] xl:grid-cols-12">
            <Skeleton className="h-72 rounded-xl xl:col-span-8" />
            <Skeleton className="h-72 rounded-xl xl:col-span-4" />
          </div>
        </div>
      </div>
    </div>
  );
}
